import { render, staticRenderFns } from "./DecorKidDialog.vue?vue&type=template&id=66ced86e&"
import script from "./DecorKidDialog.vue?vue&type=script&lang=js&"
export * from "./DecorKidDialog.vue?vue&type=script&lang=js&"
import style0 from "./DecorKidDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports